const LATEST_ARTICLES_CAROUSEL_PREFIX = "LatestArticlesCarousel";

export const LATEST_ARTICLES_CAROUSEL_CLASSES = {
  header: `${LATEST_ARTICLES_CAROUSEL_PREFIX}-header`,
  subtitle: `${LATEST_ARTICLES_CAROUSEL_PREFIX}-subtitle`,
  title: `${LATEST_ARTICLES_CAROUSEL_PREFIX}-title`,
  ctaLink: `${LATEST_ARTICLES_CAROUSEL_PREFIX}-ctaLink`,
};
